import React from 'react'
import { Edit } from '../../atoms/NewIcons'
import { Button, FormField } from '../..'
import useTrans from '../../../hooks/useTrans'

const IndirizzoCardCheckout = ({ indirizzo, variant, onClick }) => {
  const t = useTrans()

  return (
    <div className="indirizzo-card-checkout">
      <FormField className="checkout__formfield">
        {indirizzo ? (
          <div className={'indirizzo-card-checkout__content'}>
            <div>
            {indirizzo.ragione_sociale ? (
              <strong>{indirizzo.ragione_sociale}</strong>
            ) : (
              <strong>{indirizzo.nome} {indirizzo.cognome}</strong>
            )}
              <p>
                {indirizzo.indirizzo +
                  ' ' +
                  indirizzo.citta +
                  ' ' +
                  indirizzo.cap +
                  ' ' +
                  indirizzo.nazione?.nome}
              </p>
            </div>
            <Button
              onClick={onClick}
              label={
                variant === 'spedizione'
                  ? t('Modifica indirizzo di consegna')
                  : t('Modifica indirizzo di fatturazione')
              }
              variant="ghost"
              size="medium"
              icon={<Edit />}
              icon_pos="left"
            />
          </div>
        ) : (
          <div className={'indirizzo-card-checkout__content'}>
            <div>
              <p>
                {variant === 'spedizione'
                  ? t('Non hai nessun indirizzo di consegna salvato come predefinito.')
                  : t('Non hai nessun indirizzo di fatturazione salvato come predefinito.')}
              </p>
            </div>
            <Button
              onClick={onClick}
              label={
                variant === 'spedizione'
                  ? t('Aggiungi un nuovo indirizzo di consegna')
                  : t('Aggiungi nuovi dati di fatturazione')
              }
              variant="ghost"
              size="medium"
              icon={<Edit />}
              icon_pos="left"
            />
          </div>
        )}
      </FormField>
    </div>
  )
}

export default IndirizzoCardCheckout
